<div class="page">
    <div class="header">
        <app-details-header [selectedTool]="selectedTool"
                            [loading]="loading"
                            (onInvalidateTool)="invalidateTool($event)"
                            (onRevalidateTool)="revalidateTool($event)"
                            (closeModal)="onModalClose($event)"></app-details-header>
        <app-tabs [tabs]="tabs" [material]="false">
        </app-tabs>
    </div>
    <div class="content">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
        <app-fab *ngIf="shouldRenderModifiers(selectedTool)"
                 [items]="fabItems"
                 library="fontawesome"
                 variant="fa-edit">
        </app-fab>
    </div>
</div>
<app-tool-engrave-modal
    [selectedTool]="selectedTool"
    [toolsToEngrave]="toolDatamatrix"
    (closeModal)="onModalClose($event)"
    (regenerateDataMatrix)="onRegenerateDataMatrix()">
</app-tool-engrave-modal>

<app-tool-reset-modal
    [selectedTool]="selectedTool"
    (onRowAlertClicked)="onRowAlertClick($event)"
    (resetTool)="isInUse()">
</app-tool-reset-modal>

<app-confirm-delete-modal
    [selectedTool]="selectedTool"
    [scannedTools]="scannedTools"
    (confirmDelete)="onConfirmDeleteTool($event)">
</app-confirm-delete-modal>

<app-tool-backup-modal
    [loading]=requestInProgress
    [selectedTool]="selectedTool"
    [toolBackups]="toolBackups"
    (saveBackups)="onSaveBackups($event)">
</app-tool-backup-modal>

<app-issue-modal
    [hasCancel]="false"
    [hasApprove]="true"
    [hasReject]="true"
    [isLoading]="loading"
    (promoteToTicket)="onPromoteToTicket($event)"
    (reject)="onReject($event)">
</app-issue-modal>

<app-ticket-promote-modal
    (create)="createTicket($event)">
</app-ticket-promote-modal>

<app-confirmation-modal #resetConfirmation
                        (confirmEvent)="onResetTool()"
                        [isConfirmationInProgress]="requestInProgress"
                        [confirmOnlyMode]="true"
                        [title]=" 'admin.tools.details.reset-confirmation-modal.title' | translate"
                        [question]="'admin.tools.details.reset-confirmation-modal.question' | translate:{toolName: selectedTool?.name}"
                        [message]="'admin.tools.details.reset-confirmation-modal.message' | translate:{action: inUseActions}">
</app-confirmation-modal>

<app-confirmation-modal #invalidateConfirmation
                        (confirmEvent)="onSubmitInvalidationReason($event)"
                        [title]="'admin.tools.details.invalidate-confirmation-modal.title' | translate"
                        [displayReasonLabel]="'admin.tools.details.invalidate-confirmation-modal.invalidateReason' | translate"
                        [displayReasonPlaceholder]="'admin.tools.details.invalidate-confirmation-modal.reasonMessage' | translate"
                        [isConfirmationInProgress]="requestInProgress"
                        [reasonMandatory]="true"
                        [confirmWithReason]="true"
                        [confirmOnlyMode]="false">
</app-confirmation-modal>

<app-confirmation-modal #revalidateConfirmation
                        (confirmEvent)="onSubmitRevalidationReason($event)"
                        [title]="'admin.tools.details.revalidate-confirmation-modal.title' | translate"
                        [displayReasonLabel]="'admin.tools.details.revalidate-confirmation-modal.revalidateReason' | translate"
                        [displayReasonPlaceholder]="'admin.tools.details.revalidate-confirmation-modal.reasonMessage' | translate"
                        [isConfirmationInProgress]="requestInProgress"
                        [reasonMandatory]="true"
                        [confirmWithReason]="true"
                        [confirmOnlyMode]="false">
</app-confirmation-modal>

<app-confirmation-modal #revalidateScanBadge
                        (scanEvent)="onConfirmRevalidateScanBadge($event)"
                        [title]="'admin.tools.details.revalidate-confirmation-modal.title' | translate"
                        [question]="'admin.tools.details.revalidate-confirmation-modal.scanBadgeQuestion' | translate"
                        [message]="'admin.tools.details.revalidate-confirmation-modal.scanBadgeMessage' | translate">
</app-confirmation-modal>

<app-confirmation-modal #invalidateScanBadge
                        (scanEvent)="onConfirmScanBadge($event)"
                        [title]="'admin.tools.details.invalidate-confirmation-modal.title' | translate"
                        [question]="'admin.tools.details.invalidate-confirmation-modal.scanBadgeQuestion' | translate"
                        [message]="'admin.tools.details.invalidate-confirmation-modal.scanBadgeMessage' | translate"
                        [displayReasonMode]="false">
</app-confirmation-modal>

<app-operations-for-return-modal (create)="onOperationInfoApproved($event)"></app-operations-for-return-modal>
<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage"
                        [confirmOnlyMode]="true"
                        [showConfirmButton]="false ">
</app-confirmation-modal>
